import styled from 'styled-components';

export const IdentityStyles = styled.div`
  .ant-checkbox + span {
    font-size: 16px;
  }
`;
